import { apiCall } from "./service";
import { URL_EXPORT, URL_RUNBOOKS } from "./URL";

export const api = {

  getExport(params) {
    const queryParams = Object.entries(params)
      .filter(([_, value]) => value !== null && value !== undefined)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    let baseUrl = URL_EXPORT;

    if(params.category === 4) {
      baseUrl = `${URL_RUNBOOKS}/export`;
    }
    else if(params.category === 5) {
      baseUrl = `${URL_EXPORT}/timeline`;
    }
    
    const url = `${baseUrl}${queryParams ? `?${queryParams}` : ""}`;
    return apiCall.getFile({
      url,
      headers: {
        Accept:
          "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Content-Type": "blob",
      },
      responseType: "arraybuffer",
    });
  },

  getTimesheetExport(params) {
    const queryParams = Object.entries(params)
      .filter(([_, value]) => value !== null && value !== undefined && value !== "")
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    const url = `${URL_EXPORT}/timesheets${queryParams ? `?${queryParams}` : ""}`;
    return apiCall.getFile({
      url,
      headers: {
        Accept:
          "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "Content-Type": "blob",
      },
      responseType: "arraybuffer",
    });
  },
};

export default api;
